import { render, staticRenderFns } from "./uploadMoreVideo.vue?vue&type=template&id=531d246a"
import script from "./uploadMoreVideo.vue?vue&type=script&lang=js"
export * from "./uploadMoreVideo.vue?vue&type=script&lang=js"
import style0 from "./uploadMoreVideo.vue?vue&type=style&index=0&id=531d246a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports